import axios from ".";

export const getOrders = (params?: any) => {
  return axios({
    method: "GET",
    url: `/orders`,
    params,
  });
};
export const getOrderById = (orderId: number) => {
  return axios({
    method: "GET",
    url: `/orders/${orderId}`,
  });
};
export const getInvoices = (params?: any) => {
  return axios({
    method: "GET",
    url: `/invoices`,
    params,
  });
};
export const getTransactionsById = (invoiceId: number, params?: any) => {
  return axios({
    method: "GET",
    url: `/invoices/${invoiceId}/transactions`,
    params,
  });
};

export const generateTempOrderId = () => {
  return axios({
    method: "POST",
    url: `/orders/generate-id`,
  });
};

export const createOrder = (data: any) => {
  return axios({
    method: "POST",
    url: `/orders`,
    data,
  });
};

export const updateOrderAmount = (data: any, orderId: number) => {
  return axios({
    method: "PUT",
    url: `/orders/${orderId}`,
    data,
  });
};

export const generateTempInvoiceId = (tenantId: number) => {
  return axios({
    method: "POST",
    url: `/invoices/generate-id`,
    params: {
      tenantId,
    }
  });
};

export const createInvoice = (data: any) => {
  return axios({
    method: "POST",
    url: `/invoices`,
    data,
  });
};

export const addAdjustmentToInvoice = (data: any, invoiceId?: any) => {
  return axios({
    method: "POST",
    url: `/invoices/${invoiceId}/adjustments`,
    data,
  });
};

export const getInvoiceById = (invoiceId: number) => {
  return axios({
    method: "GET",
    url: `/invoices/${invoiceId}`,
  });
}

export const getAllOrders = () => {
  return axios({
    method: "GET",
    url: `/orders/ids`,
  });
};